import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AvatarModule } from "ngx-avatar";
import { LazyLoadImageModule } from "ng-lazyload-image";
import { OwlModule } from "ngx-owl-carousel";
import { CarouselModule } from "ngx-owl-carousel-o";
import { RecaptchaModule, RecaptchaFormsModule } from "ng-recaptcha";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatSelectModule } from "@angular/material/select";
import { VgBufferingModule } from "@videogular/ngx-videogular/buffering";
import { VgControlsModule } from "@videogular/ngx-videogular/controls";
import { VgCoreModule } from "@videogular/ngx-videogular/core";
import { VgOverlayPlayModule } from "@videogular/ngx-videogular/overlay-play";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { MatSliderModule } from "@angular/material/slider";
import { TimelineModule } from "primeng/timeline";
import { CardModule } from "primeng/card";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { HttpClientModule } from "@angular/common/http";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { DragAndDropDirective } from "../drag-and-drop.directive";
import { CalendarModule } from "primeng/calendar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TabViewModule } from "primeng/tabview";
import { TableModule } from "primeng/table";
import { AccordionModule } from "primeng/accordion";

@NgModule({
  declarations: [DragAndDropDirective],
  imports: [
    // CommonModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AvatarModule,
    LazyLoadImageModule,
    OwlModule,
    CarouselModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    MatSelectModule,
    MatExpansionModule,
    MatSelectModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    NgxDatatableModule,
    MatSliderModule,
    TimelineModule,
    CardModule,
    MatButtonToggleModule,
    OwlModule,
    HttpClientModule,
    MatSnackBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    DragAndDropDirective,
    CalendarModule,
    MatTooltipModule,
    TabViewModule,
    TableModule,
    AccordionModule,
  ],
})
export class SharedModule {}
